import { render, staticRenderFns } from "./CounterItem.html?vue&type=template&id=278a0ee0&scoped=true&"
import script from "./CounterItem.ts?vue&type=script&lang=ts&"
export * from "./CounterItem.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/counter/_counter.scss?vue&type=style&index=0&id=278a0ee0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a0ee0",
  null
  
)

export default component.exports